import {alias, createMany, exact, incomplete, middleware, path} from '@acng/frontend-voyager';
import {globalValue} from '@acng/frontend-relativity';
import {HIDDEN} from '@acng/frontend-bounty/dom/attribute.js';

import {userRoute} from '../../userPool/config/routes.js';
import {mainView, stickyView} from '../../layout/service/sequence.js';
import {ctxSearchParams} from '../../core/context/search-params.js';
import {feature} from './template.js';

userRoute.create(
  alias("fmotd"),
  incomplete,
  () => !feature[HIDDEN],
  createMany(
    [path('/fmotd'), mainView(feature, 'main')],
    [
      incomplete,
      exact('/movies/top'),
      middleware(async () => {
        // The search params are not present yet! So *await* it and be fine.
        if (globalValue(await ctxSearchParams).size || window.innerWidth > 1024) {
          throw 'hide fmotd';
        }
      }),
      stickyView(feature, 'teaser'),
    ]
  )
);
